"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M13.3333 17.924c.6991-.3945.9388-1.2688.5355-1.9527-.4033-.6838-1.297-.9184-1.996-.5238-.6991.3945-.9389 1.2688-.5356 1.9526.4034.6839 1.297.9185 1.9961.5239z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.8977 10.2454 2.5h7.5716v1.8906L23 7.4328s-5.183 9.8338-5.6208 10.6134c-.4379.7795-1.2256 2.091-2.2904 2.7128-1.2202.7126-2.6798.9218-4.0577.5816-1.3779-.3401-2.5612-1.2019-3.2896-2.3955L1 7.8977zm10.35-3.4916h4.5186l-.0001 7.4045L11.35 4.4061zm.4888 15.1512a3.4728 3.4728 0 0 0 2.2513-.435 3.3794 3.3794 0 0 0 1.0773-.9963c.7312-1.0584.7779-2.471.1026-3.5776l-1.2423-2.0358-5.8609 3.4109 1.2477 2.0445c.5186.8499 1.4236 1.4431 2.4243 1.5893zm-4.6707-5.2705 5.8609-3.4108-3.5017-5.7383-5.8556 3.4196 3.4964 5.7295zm10.6489-1.2109V6.6135l2.6109 1.5325-2.6109 4.9299z"
  })];
};

exports.default = _default;